import React, { useState } from "react";
import StudioFilter from "../UserFilter/StudioFilter";
import { t } from "i18next";
import {
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { useSelector } from "react-redux";
import {
  useAssociaAdminMutation,
  useDisassociaAdminMutation,
  useGetStudiosQuery,
} from "../../../../features/api/admin/gestisciStudioApi";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import AddHomeWorkRoundedIcon from "@mui/icons-material/AddHomeWorkRounded";
import CoreButtonIcon from "../CoreButtonIcon/CoreButtonIcon";
import { toast } from "react-toastify";
import { ROLE } from "../../../../utils/constants/profiles";

const AssociateStudiTable = ({ adminData = [], adminId, refetch }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const role = useSelector((state) => state.app.role);
  const [studio, setStudio] = useState("");
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");

  const { data: studios, isLoading: isLoadingStudios } = useGetStudiosQuery({
    ...{ currentPage: 1, startRow: 0, endRow: TABLE_ROWS_NUMBER },
    value: debouncedInputStudioValue,
  });

  const [dissociaAdmin] = useDisassociaAdminMutation();
  const [associaAdmin] = useAssociaAdminMutation();
  const handleDisassociateAdmin = (el) => {
    const disassociateData = {
      adminId: adminId,
      studioId: el.studioId,
    };
    dissociaAdmin(disassociateData).then((res) => {
      if (res.data.Result === 1) {
        toast.success(t("AdminUnassociated"));
        refetch();
      } else {
        toast.error(res.data.Exception);
      }
    });
  };

  const handleAssociated = () => {
    const bodyData = {
      studioId: studio.id,
      adminId: adminId,
    };

    associaAdmin(bodyData).then((res) => {
      if (res.data.Result === 1) {
        toast.success(t("OperatorAssociated"));
        setStudio(null);
        refetch();
      } else {
        toast.error(t("OperatorNotAssociated"));
      }
    });
  };

  return (
    <div>
      <h3 className="flex">
        {t("StudioAssociated")}
        <div
          className="w-6 h-6 mx-4 rounded-3xl"
          style={{ backgroundColor: `${colorPrimary}` }}
        >
          <small className="text-white flex justify-center">
            {adminData?.length}
          </small>
        </div>
      </h3>

      {role === ROLE.ADMIN && (
        <div className="py-6 flex space-x-2">
          <div className="w-full">
            <StudioFilter
              selectedUser={studio}
              setSelectedUser={(v) => setStudio(v)}
              usersList={studios?.Data?.items}
              setDebouncedInputUserValue={setDebouncedInputStudioValue}
            />
          </div>
          <div>
            <CoreButtonIcon
              className={!studio ? "text-gray-600" : "text-blue-600  "}
              icon={
                <AddHomeWorkRoundedIcon
                  fontSize="small"
                  className={!studio ? "text-gray-600" : "text-blue-600  "}
                />
              }
              disabled={!studio}
              testo={t("Associate")}
              onClick={handleAssociated}
            />
          </div>
        </div>
      )}
      <TableContainer component={Paper} elevation={4}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("Name")}</TableCell>
              <TableCell>{t("Actions")}</TableCell>
            </TableRow>
          </TableHead>

          {adminData?.map((el) => (
            <TableRow className="hover:shadow-md" key={el.id}>
              <TableCell>{el.studioName}</TableCell>

              <TableCell>
                <IconButton
                  variant="outlined"
                  onClick={() => handleDisassociateAdmin(el)}
                  disabled={role !== ROLE.ADMIN}
                >
                  <HighlightOffRoundedIcon
                    fontSize="small"
                    className={
                      role !== ROLE.ADMIN ? "text-gray" : "text-rose-700"
                    }
                  />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </Table>
        {adminData?.length === 0 && (
          <p className="flex justify-center py-2 text-gray">{t("NoStudios")}</p>
        )}
      </TableContainer>
    </div>
  );
};

export default AssociateStudiTable;
